import Image from '@components/Image'
import React, { useState } from 'react'
import { Col, Container, Row, Accordion } from 'react-bootstrap'
import { Item, RealEstateDataPageComponentData } from 'types'

const Trayectory_1 = (props: RealEstateDataPageComponentData) => {
  const { titleColor, items } = props
  const [itemsArray] = useState(groupByValue(items!, 'value'))
  const [selectedValue, setSelectedValue] = useState(Object(items!)[0].value)
  const [selectedProyect, setSelectedProyect] = useState(Object(items!)[0].title)

  function groupByValue(items: Item[], key: string) {
    return items.reduce((result: any, item: any) => {
      ;(result[item[key]] = result[item[key]] || []).push(item)
      return result
    }, {})
  }
  return (
    <section className={'trayectory-component a p-y-config '}>
      {/* <div className="mobile-scroll-horizontal d-flex flex-nowrap p-0 w-100">
        {Object.keys(itemsArray)
          .reverse()
          .map((key, index) => (
            <div className="mb-3">
              <div>
                <h4
                  onClick={() => setSelectedValue(key)}
                  style={{ color: selectedValue === key ? titleColor : '#191919' }}
                  className={
                    'item-selector mt-lg-4 mt-3 mb-3 cursor-pointer ' +
                    (selectedValue === key ? 'active' : '')
                  }
                >
                  {key}
                </h4>
                <div className="d-flex justify-content-start proyects">
                  {items
                    ?.filter((item) => item.value === key)
                    .map((element, index) => (
                      <p
                        className="item mb-2 cursor-pointer"
                        key={index}
                        style={{ opacity: element.title === selectedProyect ? 1 : 0.4 }}
                        onClick={() => setSelectedProyect(element.title)}
                      >
                        {element.title}
                      </p>
                    ))}
                </div>
              </div>
            </div>
          ))}
      </div> */}
      <Container fluid>
        <Row>
          <Col className="d-lg-flex">
            <div className="list-items-left d-lg-block d-flex mb-4 mb-lg-0 px-5 px-lg-0">
              <Accordion
                className="d-flex d-lg-block"
                defaultActiveKey="0"
              >
                {Object.keys(itemsArray)
                  .reverse()
                  .map((key, index) => (
                    <Accordion.Item
                      className="mb-lg-3"
                      eventKey={index.toString()}
                    >
                      <Accordion.Header>
                        <h4
                          onClick={() => setSelectedValue(key)}
                          style={{ color: selectedValue === key ? titleColor : '#191919' }}
                          className={
                            'item-selector mt-lg-4 mt-3 mb-3 cursor-pointer ' +
                            (selectedValue === key ? 'active' : '')
                          }
                        >
                          {key}
                        </h4>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="d-flex justify-content-start proyects">
                          {items
                            ?.filter((item) => item.value === key)
                            .map((element, index) => (
                              <p
                                className="item mb-2 cursor-pointer"
                                key={index}
                                style={{ opacity: element.title === selectedProyect ? 1 : 0.4 }}
                                onClick={() => setSelectedProyect(element.title)}
                              >
                                {element.title}
                              </p>
                            ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
              </Accordion>
            </div>
            <div className="preview_projects">
              {items
                ?.filter((item) => item.title === selectedProyect)
                .map((element, index) => (
                  <div
                    className="item cursor-pointer"
                    key={index}
                    style={{ opacity: element.title === selectedProyect ? 1 : 0.7 }}
                    onClick={() => setSelectedProyect(element.title)}
                  >
                    <Image
                      className="img-active w-100"
                      objectFit="cover"
                      alt="proyect-active"
                      image={element.image_gatsby!}
                    />
                    <div className="d-flex mt-lg-5 mt-4 px-lg-0 px-5 align-items-center justify-content-between">
                      <div>
                        <h2 style={{ color: titleColor || '#191919' }}>{element.title}</h2>
                        <p className="text-bold">{element.paragraph}</p>
                      </div>
                      <div>
                        <p>{element.subtitle}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
export default Trayectory_1
